import { useForm } from "react-hook-form";
import { useEffect } from "react";
import { Modal, TextInput, FormError, Button } from "@components";

export default function SaveAsTemplateModal({
  isOpen,
  onClose,
  onSave,
  loading,
  defaultName = "",
}) {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ defaultValues: { name: "" } });

  useEffect(() => {
    if (isOpen) {
      reset({ name: defaultName });
    }
  }, [isOpen, defaultName, reset]);

  const onSubmit = async ({ name }) => {
    if (!name.trim()) return;
    await onSave(name.trim());
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Save as new template"
      size="sm"
    >
      <form onSubmit={handleSubmit(onSubmit)} className="p-5 space-y-4">
        <TextInput
          name="name"
          control={control}
          placeholder="Give your template a name"
          required
          errors={errors.name}
          displayName="Template name"
          maxLength={50}
        />
        <FormError name="name" errors={errors} />
        <div className="flex gap-2">
          <Button
            type="button"
            className="shrink-0 rounded-lg"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            color="primary"
            className="shrink-0 grow rounded-lg"
            submitting={loading}
          >
            Save
          </Button>
        </div>
      </form>
    </Modal>
  );
}
